import { render, staticRenderFns } from "./adeudos.vue?vue&type=template&id=09be6464&"
import script from "./adeudos.component.ts?vue&type=script&lang=ts&"
export * from "./adeudos.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports